import { Module, MutationTree } from 'vuex'
import { RootState } from '@/store'
import { getToken } from '@/helpers/token'

export enum ActionTypes {
	SET_ERROR_STATUS = '@base/SET_ERROR_STATUS',
	SET_ERROR_MESSAGE = '@base/SET_ERROR_MESSAGE',
	SET_IS_AUTH = '@base/SET_IS_AUTH',
}

export type ErrorStatus = 403 | 500 | 503 | 404 | null

const state = {
	error: null as ErrorStatus,
	errorMessage: '',
	isAuth: !!getToken(),
}

export type State = typeof state

const mutations: MutationTree<State> = {
	[ActionTypes.SET_ERROR_STATUS](state, value: ErrorStatus) {
		state.error = value
	},
	[ActionTypes.SET_ERROR_MESSAGE](state, value: string) {
		state.errorMessage = value
	},
	[ActionTypes.SET_IS_AUTH](state, value: boolean) {
		state.isAuth = value
	},
}

const Base: Module<typeof state, RootState> = {
	state,
	mutations,
}

export default Base
